import { useState, useEffect, useCallback } from 'react';
import { getTemplateHistory } from '../api/template-history.api';
import { TemplateHistoryFilters, HistoryItem } from '../types/template-history.types';
import { toast } from 'react-toastify';

export const useTemplateHistory = () => {
    const [list, setList] = useState<HistoryItem[]>([]);
    const [total, setTotal] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    
    const [filters, setFilters] = useState<TemplateHistoryFilters>({
        page: 1,
        limit: 10,
        templateType: '',
        agentName: ''
    });

    const fetchHistory = useCallback(async () => {
        setIsLoading(true);
        try {
            // Eliminar propiedades con strings vacíos para evitar error 422 del backend
            const cleanFilters = { ...filters };
            if (cleanFilters.templateType === '') delete cleanFilters.templateType;
            if (cleanFilters.agentName === '') delete cleanFilters.agentName;

            const response = await getTemplateHistory(cleanFilters);
            setList(response.data || []);
            setTotal(response.meta?.total || 0);
        } catch (error) {
            console.error("Error fetching template history:", error);
            toast.error("Ocurrió un error al cargar el historial de plantillas.");
        } finally {
            setIsLoading(false);
        }
    }, [filters]);

    useEffect(() => {
        fetchHistory();
    }, [fetchHistory]);

    const handlePageChange = (newPage: number) => {
        setFilters(prev => ({ ...prev, page: newPage }));
    };

    const handleFilterChange = (key: keyof TemplateHistoryFilters, value: any) => {
        setFilters(prev => ({ ...prev, [key]: value, page: 1 }));
    };

    const refresh = () => {
        fetchHistory();
    };

    return {
        list,
        total,
        isLoading,
        filters,
        handlePageChange,
        handleFilterChange,
        refresh
    };
};
